import React, { memo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { getUsers } from 'services/api/user';
import Autocomplete from '@mui/material/Autocomplete';
import MDInput from 'components/MDInput';

// Loading component to display a loading message
const Loading = () => <div>Yükleniyor</div>;

function Users({ responsibles, updateResponsibles }) {
    // Fetch users using useQuery hook
    const {
        data: users,
        isLoading,
        error,
    } = useQuery({
        queryKey: ['fetchUsers'],
        queryFn: () => getUsers().then((rp) => rp.data.result),
    });

    // If data is loading, show loading message
    if (isLoading) return <Loading />;

    // If there's an error, show error message
    if (error) return <div>Error: {error.message}</div>;

    // If users data is available, render the Autocomplete component
    return <UsersAutocomplete responsibles={responsibles} updateResponsibles={updateResponsibles} options={users} />;
}

// UsersAutocomplete component renders the Autocomplete component
const UsersAutocomplete = memo(({ responsibles, updateResponsibles, options }) => (
    <Autocomplete
        multiple
        value={responsibles || []}
        options={options || []}
        getOptionLabel={(option) => option.username || ''}
        isOptionEqualToValue={(option, value) => option._id === value._id}
        onChange={(_, value) => updateResponsibles(value)}
        renderInput={(params) => <MDInput {...params} variant="standard" />}
    />
));

export default memo(Users);
